"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.login = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var classnames_1 = require("classnames");
var LoginAction_1 = require("@/pages/common/actions/LoginAction");
var WindowApi_1 = require("@/api/browser/WindowApi");
var LoginFormComponent_1 = require("@/pages/common/components/LoginFormComponent");
var mapStateToProps = function (state, ownProps) { return (__assign(__assign({}, state.login), { email: state.existingLogin ? state.existingLogin.email : '', persist: ownProps.persist ? ownProps.persist : false, lang: state.layout.language.languages.filter(function (it) { return it.id === state.layout.language.current; })[0].code1 })); };
var mapDispatchToProps = function (dispatch) { return ({
    onLoginSubmit: function (loginFields) { return dispatch(LoginAction_1.default.onLoginSubmit(loginFields)); },
    onLoginCloseClick: function () { return dispatch(LoginAction_1.default.onLoginCloseClick()); },
    facebookLogin: function () { return dispatch(LoginAction_1.default.facebookLogin()); },
}); };
exports.login = function (props) {
    var classnames = props.persist ? 'c-login' : classnames_1.default([
        'l-fullscreen-dim',
        'l-fullscreen-dim--center',
        'c-login',
        {
            'c-login--active': props.isActive,
            'l-fullscreen-dim--active': props.isDim,
        },
    ]);
    var classnamesMain = props.persist ?
        'c-login__main c-login__main--persist' :
        classnames_1.default(['c-login__main']);
    var classnamesClose = props.persist ? 'u-hidden' : 'c-login__close';
    var onLoginPanelClick = function (event) {
        if (event.currentTarget !== event.target)
            return;
        props.onLoginCloseClick();
    };
    var defaultUi = {
        isLoading: props.isLoading,
        email: props.email,
        lang: props.lang,
    };
    var renderFacebookLogin = function (props) { return (React.createElement("div", null,
        React.createElement("div", { className: "c-login__or" },
            React.createElement("span", { className: "c-login__or-line" }),
            props.t.nameOr,
            React.createElement("span", { className: "c-login__or-line" })),
        React.createElement("div", { className: "c-login__federal" },
            React.createElement("div", { className: "c-forms__row " },
                React.createElement("div", { className: "c-forms__col c-forms__col--range " },
                    React.createElement("button", { id: "login-facebook", onClick: props.facebookLogin, className: "o-btn o-btn--facebook o-btn--long", type: "submit" }, props.t.nameFacebook)))))); };
    return props.isDim || props.persist ? (React.createElement("div", { id: "login-panel", className: classnames, onClick: onLoginPanelClick },
        React.createElement("div", { className: classnamesMain },
            React.createElement("a", { className: classnamesClose, onClick: props.onLoginCloseClick },
                React.createElement("span", { className: "fal fa-times" })),
            React.createElement("div", { className: "c-login__title" },
                React.createElement("div", { className: "c-page-header c-page-header--center" },
                    React.createElement("div", { className: "c-page-header__body" },
                        React.createElement("div", { className: "c-page-header__title" }, props.t.nameTitle),
                        React.createElement("div", { className: "c-page-header__caption" }, props.t.nameCaption)))),
            React.createElement(LoginFormComponent_1.default, { form: props.loginFields, tForm: props.tForm, ui: defaultUi, errors: props.errors, onFormSubmit: props.onLoginSubmit }),
            defaultUi.email ? '' : renderFacebookLogin(props),
            React.createElement("div", { className: "c-login__signup" },
                props.t.nameNoAccount,
                React.createElement("a", { href: WindowApi_1.toAbsoluteUrl("/" + props.lang + "/account/register"), className: "o-textbtn" }, props.t.nameRegister))))) : null;
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(exports.login);
